var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlide2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 216,
    viewBox: "0 0 317 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5625 158.5C89.5625 161.848 90.8926 165.06 93.2603 167.427C95.6279 169.795 98.8391 171.125 102.188 171.125H228.438C230.112 171.125 231.717 170.46 232.901 169.276C234.085 168.092 234.75 166.487 234.75 164.812V76.4375C234.75 74.7633 234.085 73.1577 232.901 71.9739C231.717 70.7901 230.112 70.125 228.438 70.125H102.188C98.8391 70.125 95.6279 68.7949 93.2603 66.4272C90.8926 64.0596 89.5625 60.8484 89.5625 57.5V158.5Z",
    fill: "#329D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.053 100.044L165.707 112.444C165.13 113.289 166.24 114.311 167.039 113.6L175.252 106.444C175.474 106.267 175.785 106.4 175.785 106.711V129.067C175.785 129.378 175.385 129.511 175.208 129.289L150.346 99.5111C149.547 98.5333 148.393 98 147.105 98H146.218C143.909 98 142 99.9111 142 102.267V133.733C142 136.089 143.909 138 146.262 138C147.727 138 149.103 137.244 149.902 135.956L158.249 123.556C158.826 122.711 157.716 121.689 156.917 122.4L148.704 129.511C148.482 129.689 148.171 129.556 148.171 129.244V106.933C148.171 106.622 148.57 106.489 148.748 106.711L173.609 136.489C174.408 137.467 175.607 138 176.85 138H177.738C180.091 138 182 136.089 182 133.733V102.267C182 99.9111 180.091 98 177.738 98C176.229 98 174.852 98.7556 174.053 100.044Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5625 57.5V158.5C89.5625 161.848 90.8926 165.06 93.2603 167.427C95.6279 169.795 98.8391 171.125 102.188 171.125H228.438C230.112 171.125 231.717 170.46 232.901 169.276C234.085 168.092 234.75 166.487 234.75 164.812V76.4375C234.75 74.7633 234.085 73.1577 232.901 71.9739C231.717 70.7901 230.112 70.125 228.438 70.125H102.188C98.8391 70.125 95.6279 68.7949 93.2603 66.4272C90.8926 64.0596 89.5625 60.8484 89.5625 57.5ZM89.5625 57.5C89.5625 54.1516 90.8926 50.9404 93.2603 48.5728C95.6279 46.2051 98.8391 44.875 102.188 44.875H209.5",
    stroke: "#329D9C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218 126C221.314 126 224 123.538 224 120.5C224 117.462 221.314 115 218 115C214.686 115 212 117.462 212 120.5C212 123.538 214.686 126 218 126Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63,
    d: "M168.415 211.164C128 211.164 48 192.5 48 192.5C69.4823 181.24 85.2426 179.415 98.5 171.073L232 172L170 203.5L168.415 211.164Z",
    fill: "url(#paint0_linear_189_1111)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_1111",
    x1: 143,
    y1: 205.5,
    x2: 146.167,
    y2: 174.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CECECE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.2bd8de7b879de245991c877eb0cd774f.svg";
export { ForwardRef as ReactComponent };